
export default {
  name: "ContactDetailsTable",
};
